import type { Celebrity, CelebrityInput } from "@pushup/types";
import { api, WITH_CREDENTIALS } from "@/lib/api";

export function listCelebrities() {
  return api.get<Celebrity[]>("/admin/celebrities", WITH_CREDENTIALS);
}

export function createCelebrity(input: CelebrityInput) {
  return api.post<Celebrity>("/admin/celebrities", input, WITH_CREDENTIALS);
}

export function updateCelebrity(id: string, input: CelebrityInput) {
  return api.put<Celebrity>(
    `/admin/celebrities/${encodeURIComponent(id)}`,
    input,
    WITH_CREDENTIALS,
  );
}

export function deleteCelebrity(id: string) {
  return api.delete<void>(`/admin/celebrities/${encodeURIComponent(id)}`, WITH_CREDENTIALS);
}
